<template>
    <div :class="panelClasses">
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'BasePanel',
    props: {
        variant: {
            type: String,
            validator: (value) => {
                return ['primary', 'secondary-outlined'].includes(value);
            },
            default: 'default'
        },
    },
    computed: {
        panelClasses() {
            const map = {
                'primary': 'tw-bg-infinity-highlight-faded tw-text-infinity-primary-text',
                // 'primary-outlined': 'tw-text-infinity-primary-text tw-border-infinity-border tw-border',
                'secondary-outlined': 'tw-text-infinity-primary-text tw-border-infinity-border tw-border tw-border-solid',
            }

            return [
                'tw-p-6 tw-py-5 tw-rounded',
                map[this.variant]
            ];
        },
    },
}
</script>
